import * as React from "react";

export default function Footer(props: any) {
    return (
        <div className="Footer">
            <div className="Footer__flat"></div>
            <div className="container Footer__bg">
                <img className="Footer__bg__bg1" src="/assets/images/background/rectangle2.svg" alt=""/>
                <img className="Footer__bg__bg2" src="/assets/images/background/rectangle1.svg" alt=""/>
                <img className="Footer__bg__bg3" src="/assets/images/background/shape.svg" alt=""/>
                <img className="Footer__bg__bg4" src="/assets/images/background/circle.svg" alt=""/>
                <div className="Footer__signup">
                    <p className='Footer__signup__phead'><b>BE THE FIRST TO KNOW</b></p>
                    <p className='Footer__signup__pcontent'>Leave us an email and we'll let you know when the platform is out!</p>
                    <div className="Footer__signup__form">
                        <input type="text" placeholder='e-mail' />
                        <button>SIGN UP</button>
                    </div>
                </div>
                <div className="Footer__brand">
                    <p className='Footer__brand__name'><a href='/'><b className='txt-rock'>Rock</b><span className='txt-jvm'> the JVM</span></a></p>
                    <p className='Footer__brand__cpright'>Copyright 2018. All rights reserved</p>
                </div>
                <div className="Footer__menu">
                    <ul>
                        <li><a href='/'>HOME</a></li>
                        <li><a href='about'>ABOUT US</a></li>
                        <li><a href='how-it-works'>HOW IT WORKS?</a></li>
                        <li><a href='contact'>CONTACT US</a></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/homepage/Footer.tsx